import { render, staticRenderFns } from "./ToolVotingDetailView.vue?vue&type=template&id=01000739&scoped=true"
import script from "./ToolVotingDetailView.vue?vue&type=script&lang=ts"
export * from "./ToolVotingDetailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01000739",
  null
  
)

export default component.exports